export enum Timing {
	BEFORE_STATE_UPDATE = "BEFORE_STATE_UPDATE",
	AFTER_STATE_UPDATE = "AFTER_STATE_UPDATE",
}

export abstract class Effect {
	static key: string;
	private timing: Timing = Timing.AFTER_STATE_UPDATE;
	private animationOrder: number = 0;
	private unbounded: boolean = false;

	getTiming(): Timing {
		return this.timing;
	}

	setTiming(timing: Timing): void {
		this.timing = timing;
	}

	getAnimationOrder(): number {
		return this.animationOrder;
	}

	setAnimationOrder(order: number): void {
		this.animationOrder = order;
	}

	getUnbounded(): boolean {
		return this.unbounded;
	}

	setUnbounded(unbounded: boolean): void {
		this.unbounded = unbounded;
	}

	getAnimationKey(): string {
		return (this.constructor as any).key;
	}
}
